import { modifier } from 'ember-modifier';

// Disables the browser's autocorrect, spellcheck, etc
export default modifier((element: HTMLElement) => {
  element.setAttribute('autocomplete', 'off');
  element.setAttribute('autocorrect', 'off');
  element.setAttribute('autocapitalize', 'off');
  element.setAttribute('spellcheck', 'false');
});
